import { createStore, combineReducers } from "redux";

// Reducers
import { article, desings, processDesings, manufacturingOrder, historical } from "./reducers";

const reducers = combineReducers({
  article,
  desings,
  processDesings,
  manufacturingOrder,
  historical
});

export default createStore(reducers);
